import React from "react";
import HeroImage from "../Home/HeroImage";

export function About() {
	return (
		<div className="bg-white py-6 sm:py-8 lg:py-12 mb-24">
			<div className="mx-auto max-w-screen-xl px-4 md:px-8">
				<div className="grid gap-8 md:grid-cols-2 lg:gap-12">
					<div>
						<div className="h-64 overflow-hidden rounded-lg bg-white-100 md:h-full lg:h-full">
							{/* <img
								src={process.env.PUBLIC_URL + "/images/About.jpg"}
								loading="lazy"
								alt="by Martin Sanchez"
								 className="h-full w-full object-cover object-center"
							/> */}
							<HeroImage src={process.env.PUBLIC_URL + "/images/About.jpg"} />
						</div>
					</div>

					<div className="md:pt-8">
						<p className="text-center text-xl font-bold text-indigo-500 md:text-left">
							Who we are
						</p>

						<h1 className="mb-4 text-center text-4xl font-bold text-gray-800 sm:text-5xl md:mb-6 md:text-left">
							About Us
						</h1>

						<p className="mb-6 text-gray-500 sm:text-2xl md:mb-8">
							Welcome to DesignFirst, where creativity meets precision. Nestled
							in the heart of Edison, NJ, we are a small, passionate start-up
							with a bold vision: to transform ideas into digital masterpieces.
							Every project we undertake is designed with care, developed with
							cutting-edge technology, and deployed with flawless execution.
							<br />
							<br />
							At DesignFirst, we believe in the power of simplicity and
							elegance. Our team is dedicated to delivering intuitive,
							user-focused designs that not only capture attention but also
							drive success. We may be small, but our ambition is
							vast—empowering businesses, like yours, to thrive in the digital
							world.
						</p>

						{/* <h2  className="mb-2 text-center text-xl font-semibold text-gray-800 sm:text-2xl md:mb-4 md:text-left">
							About us
						</h2>

						<p  className="mb-6 text-gray-500 sm:text-lg md:mb-8">
							This is a section of some simple filler text, also known as
							placeholder text. It shares some characteristics of a real written
							text but is random or otherwise generated. It may be used to
							display a sample of fonts or generate text for testing. Filler
							text is dummy text which has no meaning however looks very similar
							to real text.
						</p> */}
					</div>
				</div>
				<div className="grid gap-8 mt-16 md:grid-cols-2 lg:gap-12">
					<div className="md:pt-8">
						{/* <p className="text-center text-xl font-bold text-indigo-500 md:text-left">
							We are
						</p> */}

						<h1 className="mb-4 text-center text-4xl font-bold text-gray-800 sm:text-5xl md:mb-6 md:text-left">
							Located at
						</h1>

						<p className="mb-6 text-gray-500 sm:text-2xl md:mb-8">
							Our Office Location:
							<br />
							33 Wood Avenue South, Suite 600, Iselin, NJ 08830
						</p>

						<h2 className="mb-4 text-center text-4xl font-bold text-gray-800 sm:text-5xl md:mb-6 md:text-left">
							Call Us
						</h2>

						<p className="mb-6 text-gray-500 sm:text-2xl md:mb-8">
							We would love to hear from you!
							<br />
							Give us a call on: +1-DESIGN-4321 (+1-337-446-4321)
						</p>

						{/* <h2  className="mb-2 text-center text-xl font-semibold text-gray-800 sm:text-2xl md:mb-4 md:text-left">
							About us
						</h2>

						<p  className="mb-6 text-gray-500 sm:text-lg md:mb-8">
							This is a section of some simple filler text, also known as
							placeholder text. It shares some characteristics of a real written
							text but is random or otherwise generated. It may be used to
							display a sample of fonts or generate text for testing. Filler
							text is dummy text which has no meaning however looks very similar
							to real text.
						</p> */}
					</div>
					<div>
						<div className="h-64 overflow-hidden rounded-lg bg-gray-100 md:h-full lg:h-full">
							<iframe
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3030.848906926224!2d-74.33654438731799!3d40.567013746358015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48b03b491561639b%3A0xb21f760872cd889b!2sDesignFirst%20(Software%20Solutions)!5e0!3m2!1sen!2sca!4v1742598724891!5m2!1sen!2sca"
								width="100%"
								height="100%"
								style={{ border: 0 }}
								allowFullScreen=""
								loading="lazy"
								referrerPolicy="no-referrer-when-downgrade"
								title="Company Map"
								className="w-full h-64 sm:h-80 md:h-96 lg:h-[450px]"></iframe>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
